<template>
  <div>
    <b-card>
      <b-input-group>
        <b-input list="my-list-id"/>
        <datalist id="my-list-id">
          <option v-for="p in getPossibilities()" :key="p">{{ p }}</option>
        </datalist>
      </b-input-group>
      <b-card>{{ tree.pwd() }}</b-card>
      <b-card>{{ getPossibilities() }}</b-card>
      <b-card class="bg-light">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas viverra nunc sapien,
        non rhoncus elit tincidunt vitae. Vestibulum maximus, ligula eu feugiat molestie,
        massa diam imperdiet odio, vitae viverra ligula est id nisi. Aliquam ut molestie est.
        Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac
        turpis egestas. Phasellus at consequat dui. Aenean tristique sagittis quam,
        sit amet sollicitudin neque sodales in.
      </b-card>
      <l-form :tree="tree">
      </l-form>
    </b-card>
  </div>
</template>

<script>
import LForm from "@/components/lForm";
import tree from "@/js/trees/subjectTree";

export default {
  name      : "SentenceBuilder",
  components: {LForm},
  data() {
    return {
      tree,
    }
  },
  methods   : {
    getPossibilities() {
      const {tree} = this

      function getEndNodes(node) {
        if (node.GetChildren().length === 0) return [node]
        return node.GetChildren().reduce((prev, child) => [...prev, ...getEndNodes(child)], [])
      }

      const node     = tree.GetNode()
      const endNodes = getEndNodes(node)
      const pronoms = endNodes.map(n => n.meta.pronom).filter(p => !!p);
      const metiers = endNodes.reduce((p, n) => [...p, ...(n.meta.list || [])], []).filter(p => !!p);
      const setP    = new Set(pronoms)
      const setM    = new Set(metiers)
      return [...setP, ...setM]
    }
  },
}
</script>

<style scoped>

</style>